// AMC homepage-only tightening (2026-10-29 split). Loaded by sections/amc-home-finish.liquid before assets/amc-home-tighten.js, which calls window.amcTightenHomepage().
(function () {
  'use strict';

  function clean(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function important(element, property, value) {
    if (element && (element.style.getPropertyValue(property) !== value || element.style.getPropertyPriority(property) !== 'important')) {
      element.style.setProperty(property, value, 'important');
    }
  }

  function placeHomepageBottomBands() {
    var main = document.querySelector('#MainContent');
    var resourceNav = main && main.querySelector('.amc-cats__tools');
    var brandStrip = main && main.querySelector('.amc-bstrip');
    var brandSection = brandStrip && brandStrip.closest('.shopify-section');
    if (!main || !resourceNav) return;

    if (main.querySelector('.amc-resource-showcase')) {
      important(resourceNav, 'display', 'none');
      resourceNav.setAttribute('aria-hidden', 'true');
      var legacyResourceSection = main.querySelector('.amc-home-bottom-resources');
      if (legacyResourceSection) legacyResourceSection.remove();
      if (brandSection) important(brandSection, 'display', 'none');
      return;
    }

    if (!brandSection) return;

    var resourceSection = main.querySelector('.amc-home-bottom-resources');
    if (!resourceSection) {
      resourceSection = document.createElement('section');
      resourceSection.className = 'amc-home-bottom-resources';
      resourceSection.setAttribute('aria-label', 'Buyer resources');
      var resourceInner = document.createElement('div');
      resourceInner.className = 'page-width';
      resourceSection.appendChild(resourceInner);
    }
    var resourceContainer = resourceSection.querySelector('.page-width');
    if (resourceNav.parentElement !== resourceContainer) resourceContainer.appendChild(resourceNav);

    var resources = [
      ['Financing', 'Payment and equipment financing options'],
      ['Get a quote', 'Pricing, lead times and purchase-order support'],
      ['Planning guides', 'Sizing, capacity and site preparation'],
      ['Delivery guide', 'Freight, unloading and access requirements']
    ];
    var resourceHead = resourceNav.querySelector('.amc-cats__tools-head');
    var resourceLabel = resourceNav.querySelector('.amc-cats__tools-label');
    var resourceSub = resourceHead && resourceHead.querySelector('small');
    if (resourceLabel) resourceLabel.textContent = 'Buyer resources';
    if (resourceSub) resourceSub.textContent = 'Quotes, planning, payment and delivery';
    resourceNav.querySelectorAll('.amc-cats__tool-card').forEach(function (card, index) {
      var copy = resources[index];
      if (!copy) return;
      var title = card.querySelector('.amc-cats__tool-copy strong');
      var detail = card.querySelector('.amc-cats__tool-copy small');
      if (title) title.textContent = copy[0];
      if (detail) detail.textContent = copy[1];
      card.setAttribute('aria-label', copy[0] + ': ' + copy[1]);
    });

    if (brandStrip) {
      brandStrip.open = true;
      var brandLabel = brandStrip.querySelector('.amc-bstrip__label');
      if (brandLabel) brandLabel.textContent = 'Our family of brands';
      var brandSummary = brandStrip.querySelector('.amc-bstrip__sum');
      if (brandSummary && !brandSummary.dataset.amcStatic) {
        brandSummary.dataset.amcStatic = 'true';
        brandSummary.addEventListener('click', function (event) {
          event.preventDefault();
        });
      }
    }

    if (resourceSection.parentElement !== main ||
        resourceSection.nextElementSibling !== brandSection ||
        brandSection.nextElementSibling !== null) {
      main.append(resourceSection, brandSection);
    }
  }

  window.amcTightenHomepage = function () {
    if (!document.body || !document.body.classList.contains('index-template')) return;

    var featureBar = document.querySelector('.amc-hero__featurebar');
    if (featureBar) {
      var featureLabel = featureBar.querySelector('strong');
      var featureStatus = featureBar.querySelector('em');
      if (featureLabel) featureLabel.textContent = 'Featured equipment';
      if (featureStatus) featureStatus.textContent = 'Current catalog';
    }

    document.querySelectorAll('.amc-hero__barcode').forEach(function (barcode) {
      barcode.remove();
    });

    document.querySelectorAll('.amc-hero__identity').forEach(function (identity) {
      var heroPo = identity.querySelector('.amc-hero__po');
      var heroModel = clean(heroPo && heroPo.textContent).replace(/^Order\s*\/\s*PO\s*/i, '');
      if (!heroModel) return;
      var heroLabel = document.createElement('span');
      var heroValue = document.createElement('strong');
      heroLabel.textContent = 'Model';
      heroValue.className = 'amc-hero__model';
      heroValue.textContent = heroModel;
      identity.replaceChildren(heroLabel, heroValue);
      identity.setAttribute('aria-label', 'Model ' + heroModel);
    });

    document.querySelectorAll('.amc-cslider__card').forEach(function (card) {
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      important(card, 'height', 'auto');
      important(card, 'min-height', '0');
      important(card, 'max-height', 'none');

      [card.querySelector('.amc-cslider__media-link'), card.querySelector('.amc-cslider__imgwrap')].forEach(function (media) {
        important(media, 'height', 'auto');
        important(media, 'min-height', '0');
        important(media, 'max-height', 'none');
        important(media, 'aspect-ratio', '4 / 3');
      });

      var cardBody = card.querySelector('.amc-cslider__body');
      important(cardBody, 'height', 'auto');
      important(cardBody, 'min-height', '0');
      important(cardBody, 'max-height', 'none');
      important(cardBody, 'grid-template-rows', 'none');

      card.querySelectorAll('.amc-cslider__flag,.amc-cslider__dealbar,.amc-cslider__shipping,.amc-epa-cue,.amc-value-line').forEach(function (element) {
        element.remove();
      });

      var model = card.querySelector('.amc-cslider__model');
      if (model) {
        if (model.dataset.amcTightSku === 'true') {
          var existingLabel = model.querySelector('span');
          var existingValue = model.querySelector('strong');
          if (existingLabel) existingLabel.textContent = 'SKU';
          if (existingValue && model.dataset.amcTightSkuValue) existingValue.textContent = model.dataset.amcTightSkuValue;
        } else {
          var po = model.querySelector('.amc-cslider__po');
          var sku = clean(po && po.textContent).replace(/^Order\s*\/\s*PO\s*/i, '');
          if (sku) {
            var label = document.createElement('span');
            var value = document.createElement('strong');
            label.textContent = 'SKU';
            value.textContent = sku;
            model.replaceChildren(label, value);
            model.setAttribute('aria-label', 'SKU ' + sku);
            model.dataset.amcTightSku = 'true';
            model.dataset.amcTightSkuValue = sku;
          } else {
            model.remove();
          }
        }
      }

      var price = card.querySelector('.amc-cslider__price-column strong');
      var priceLabel = card.querySelector('.amc-cslider__price-column small');
      var compare = card.querySelector('.amc-cslider__compare-column s');
      var hasCompare = !!clean(compare && compare.textContent);
      if (priceLabel) priceLabel.textContent = 'Current price';

      var savings = card.querySelector('.amc-cslider__savings');
      if (savings) {
        var savingsPrimary = savings.querySelector('strong');
        var savingsSecondary = savings.querySelector('span');
        if (hasCompare) {
          if (savingsSecondary) savingsSecondary.textContent = 'Compare at';
        } else {
          if (savingsPrimary) savingsPrimary.textContent = (window.amcPriceLabel || 'Sale price');
          if (savingsSecondary) savingsSecondary.textContent = 'Options may vary';
        }
      }

      var action = card.querySelector('.amc-cslider__action');
      if (action && action.tagName === 'A') {
        action.textContent = 'View details';
        var productTitle = clean(card.querySelector('.amc-cslider__title') && card.querySelector('.amc-cslider__title').textContent);
        if (productTitle) action.setAttribute('aria-label', 'View details — ' + productTitle);
      }
    });

    var guideDetails = document.querySelector('.amc-guides__acc');
    if (guideDetails && !guideDetails.dataset.amcTightened) {
      guideDetails.removeAttribute('open');
      guideDetails.dataset.amcTightened = 'true';
    }

    document.querySelectorAll('body.index-template .amc-promo strong, body.index-template .amc-promo span, body.index-template .amc-promo em').forEach(function (element) {
      var value = clean(element.textContent);
      if (/big savings\s*[·-]?\s*ends soon/i.test(value)) element.textContent = 'Current equipment pricing';
    });

    document.querySelectorAll('body.index-template .amc-promo a[href*="/collections/mortuary-coolers"]').forEach(function (link) {
      var promoTitle = link.querySelector('strong');
      var promoCopy = link.querySelector('span');
      if (promoTitle) promoTitle.textContent = 'COOLER PRICING';
      if (promoCopy) promoCopy.textContent = 'Current factory-direct pricing';
      link.setAttribute('aria-label', 'Cooler pricing — current factory-direct pricing — shop coolers');
    });

    placeHomepageBottomBands();
  };
}());